/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
import { Controller } from "react-hook-form";
import { Checkbox, DatePicker, MenuItem, Radio, Select } from "../..";
import { InputWrapper } from "../InputWrapper";
import { TextField } from "../Textfield";
import { Toggle } from "../Toggle";
import { InputFormProps } from "./types";

export const FormController = ({
  name,
  controlProps,
  control,
  label,
  type,
  options,
  selectKeys,
  disabled
}: InputFormProps) => {
  const renderInputField = (onChange: any, value: any, error: any) => {
    switch (type) {
      case "checkbox":
        return <Checkbox {...controlProps} key={name} />;
      case "radio":
        return <Radio {...controlProps} key={name} />;
      case "toggle":
        return <Toggle {...controlProps} key={name} />;
      case "datepicker":
        return <DatePicker {...controlProps} key={name} name={name} control={control}/>;
      case "custom":
        return <h1>test</h1>;
      case "select":
      case "multi-select":
        return (
          <Select
            label={label}
            defaultValue=""
            variant="outlined"
            fullWidth
            multiline={type === "multi-select"}
            onChange={onChange}
            disabled={disabled}
          >
            {options?.map((option: any) => {
              const key = selectKeys?.codeKey ?? "value";
              const labelKey = selectKeys?.labelKey ?? "desc";
              return (
                <MenuItem
                  key={option[key as keyof typeof option]}
                  value={option[key as keyof typeof option]}
                >
                  {option[labelKey as keyof typeof option]}
                </MenuItem>
              );
            })}
          </Select>
        );
      default:
        return (
          <TextField
            onChange={onChange}
            error={!!error}
            value={value}
            size="small"
          />
        );
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className="w-full p-8">
          <InputWrapper
            error={!!error}
            errorText={error?.message}
            {...controlProps}
          >
            {renderInputField(onChange, value, error)}
          </InputWrapper>
        </div>
      )}
    />
  );
};
